<template>
  <div
    class="config-form-content weeducAdminIntegrations adminWeeducConfig weeduc-admin-config weeduc-admin-integrations"
  >
    <div class="weeduc-admin-integrations__intro">
      <h3 class="weeduc-admin-integrations__title">{{ $t('admin.siteConfig.integrationsTitle') }}</h3>
      <p class="weeduc-admin-integrations__lead">
        {{ $t('admin.siteConfig.integrationsLead') }}
      </p>
    </div>

    <Loader :isActive="hasReady" />

    <div class="row g-3 g-lg-4 weeduc-admin-config-layout mx-0" v-if="hasReady">
      <div class="col-12 col-lg-6 weeduc-admin-config-col">
        <div class="weeduc-admin-config-section">
          <h3 class="weeduc-admin-config-section-title">{{ $t('admin.siteConfig.pixelsSection') }}</h3>
          <p class="weeduc-admin-config-section-lead">
            {{ $t('admin.siteConfig.pixelsSectionLead') }}
          </p>

          <div class="form-group">
            <label class="form-label" for="weeducIntegrationFacebook">{{ $t('admin.siteConfig.facebookPixel') }}</label>
            <input
              id="weeducIntegrationFacebook"
              v-model="facebook"
              type="text"
              class="form-input"
              :placeholder="$t('admin.siteConfig.facebookPlaceholder')"
              autocomplete="off"
            />
            <small class="form-small-description">
              {{ $t('admin.siteConfig.facebookHint') }}
            </small>
          </div>

          <div class="form-group">
            <label class="form-label" for="weeducIntegrationGads">{{ $t('admin.siteConfig.gadsPixel') }}</label>
            <input
              id="weeducIntegrationGads"
              v-model="gads"
              type="text"
              class="form-input"
              :placeholder="$t('admin.siteConfig.gadsPlaceholder')"
              autocomplete="off"
            />
            <small class="form-small-description">
              {{ $t('admin.siteConfig.gadsHint') }}
            </small>
          </div>

          <div class="form-group">
            <label class="form-label" for="weeducIntegrationGa">{{ $t('admin.siteConfig.ga') }}</label>
            <input
              id="weeducIntegrationGa"
              v-model="ganalytic"
              type="text"
              class="form-input"
              :placeholder="$t('admin.siteConfig.gaPlaceholder')"
              autocomplete="off"
            />
            <small class="form-small-description">
              {{ $t('admin.siteConfig.gaHint') }}
            </small>
          </div>

          <div class="form-group">
            <label class="form-label" for="weeducIntegrationGtm">{{ $t('admin.siteConfig.gtm') }}</label>
            <input
              id="weeducIntegrationGtm"
              v-model="tagManager"
              type="text"
              class="form-input"
              :placeholder="$t('admin.siteConfig.gtmPlaceholder')"
              autocomplete="off"
            />
            <small class="form-small-description">
              {{ $t('admin.siteConfig.gtmHint') }}
            </small>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6 weeduc-admin-config-col">
        <div class="weeduc-admin-config-section">
          <h3 class="weeduc-admin-config-section-title">{{ $t('admin.siteConfig.rdSection') }}</h3>
          <p class="weeduc-admin-config-section-lead">
            {{ $t('admin.siteConfig.rdSectionLead') }}
          </p>

          <div class="form-group">
            <label class="form-label" for="weeducIntegrationRdRefresh">{{ $t('admin.siteConfig.rdRefresh') }}</label>
            <input
              id="weeducIntegrationRdRefresh"
              v-model="rdrefreshToken"
              type="text"
              class="form-input"
              :placeholder="$t('admin.siteConfig.rdRefreshPlaceholder')"
              autocomplete="off"
            />
            <small class="form-small-description">
              {{ $t('admin.siteConfig.rdRefreshHint') }}
            </small>
          </div>

          <div class="form-group">
            <label class="form-label" for="weeducIntegrationRdCode">{{ $t('admin.siteConfig.rdCode') }}</label>
            <input
              id="weeducIntegrationRdCode"
              v-model="rdcode"
              type="text"
              class="form-input"
              :placeholder="$t('admin.siteConfig.rdCodePlaceholder')"
              autocomplete="off"
            />
            <small class="form-small-description">
              {{ $t('admin.siteConfig.rdCodeHint') }}
            </small>
          </div>

          <div class="form-group">
            <label class="form-label" for="weeducIntegrationRdSecret">{{ $t('admin.siteConfig.rdSecret') }}</label>
            <input
              id="weeducIntegrationRdSecret"
              v-model="rdSecret"
              type="text"
              class="form-input"
              :placeholder="$t('admin.siteConfig.rdSecretPlaceholder')"
              autocomplete="off"
            />
            <small class="form-small-description">
              {{ $t('admin.siteConfig.rdSecretHint') }}
            </small>
          </div>

          <div class="form-group">
            <label class="form-label" for="weeducIntegrationRdClient">{{ $t('admin.siteConfig.rdClient') }}</label>
            <input
              id="weeducIntegrationRdClient"
              v-model="rdClient"
              type="text"
              class="form-input"
              :placeholder="$t('admin.siteConfig.rdClientPlaceholder')"
              autocomplete="off"
            />
            <small class="form-small-description">
              {{ $t('admin.siteConfig.rdClientHint') }}
            </small>
          </div>
        </div>
      </div>
    </div>

    <div class="buttons-container weeduc-admin-site-form-actions">
      <div class="button d-flex flex-wrap gap-2 justify-content-end" v-show="hasSite">
        <button type="button" class="btn btn-block btn-content" @click="save()">
          {{ $t('admin.siteConfig.saveEditPublish') }}
        </button>
        <button type="button" class="btn btn-block btn-content" @click="clearCache()">
          {{ $t('admin.siteConfig.clearCache') }}
        </button>
      </div>
      <div class="button" v-show="!hasSite">
        <button type="button" class="btn btn-block btn-content" @click="save()">
          {{ $t('admin.siteConfig.createPublish') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/site'
import apiSiteIntegration from '@/utils/Site/integrations'
import { mapState } from 'vuex'
import Loader from '@/components/Loader/loader.vue'
import { toast } from 'vue3-toastify'

export default {
  name: 'WeeducAdminIntegrations',
  components: {
    Loader,
  },
  props: {
    saved: Boolean,
  },
  data() {
    return {
      hasSite: false,
      facebook: '',
      tagManager: '',
      ganalytic: '',
      gads: '',
      rdSecret: '',
      rdClient: '',
      rdcode: '',
      rdrefreshToken: '',
      id: null,
      hasSaved: false,
      hasReady: false,
      windowWidth: window.innerWidth,
    }
  },
  computed: {
    ...mapState(['token']),
  },
  methods: {
    async getConfigSite() {
      try {
        const response = await apiSiteIntegration.getIntegrationData(this.token)
        this.hasSite = true
        this.tagManager = response.tagManagerCode ?? ''
        this.ganalytic = response.googleAnalyticsCode ?? ''
        this.facebook = response.facebookPixelCode ?? ''
        this.gads = response.googleAdsCode ?? ''
        this.rdSecret = response.rdsecretClient ?? ''
        this.rdClient = response.rdclienteId ?? ''
        this.rdcode = response.rdcode ?? ''
        this.rdrefreshToken = response.rdrefreshToken ?? ''
        this.hasReady = true
      } catch (error) {
        toast.error(this.$t('admin.siteConfig.integrationsLoadError'))
        console.error('Erro ao carregar as configurações do Site', error)
        this.hasReady = true
      }
    },
    async editSite() {
      this.hasReady = false
      const obj = {
        tagManagerCode: this.tagManager,
        googleAnalyticsCode: this.ganalytic,
        facebookPixelCode: this.facebook,
        googleAdsCode: this.gads,
        rdsecretClient: this.rdSecret,
        rdclienteId: this.rdClient,
        rdcode: this.rdcode,
        rdrefreshToken: this.rdrefreshToken,
      }
      try {
        await apiSiteIntegration.putIntegrationData(this.token, obj)
        await this.getConfigSite()
        toast.success(this.$t('admin.siteConfig.integrationsSaveSuccess'))
      } catch (error) {
        toast.error(this.$t('admin.siteConfig.integrationsSaveError'))
        console.error('Erro ao Editar Site', error)
        this.hasReady = true
      }
    },
    async clearCache() {
      try {
        await api.clearCache(this.token)
        toast.success(this.$t('admin.siteConfig.cacheCleared'))
      } catch (error) {
        toast.error(this.$t('admin.siteConfig.cacheError'))
        console.error(error)
      }
    },
    save() {
      this.editSite()
      this.hasSaved = true
    },
  },
  created() {
    this.getConfigSite()
  },
}
</script>

<style scoped>
@import url('@/css/weeduc/admin/dashboard-weflix-shell.css');
@import '@/css/weeduc/admin/config.css';
@import '@/css/weeduc/admin/integrations.css';
</style>
